import { convertDate } from "../../../../../../libs/dateUtils";
import { getImmobilizedById } from "../../service";
import { IImmobilizedInventory } from "../models";

export async function getImmobilizedByid(id, token, setDefaultValues, setState, setNeedSpinner) {
  const data = await getImmobilizedById(id, token);
  const dataConvertDate = convertDateOfData(data);
  setDefaultValues(dataConvertDate);
  setState(whoBooleanState(data));
  setTimeout(() => {
    setNeedSpinner(false);
  }, 1000);
}

function whoBooleanState(obj: IImmobilizedInventory) {
  if (obj?.isDeleted) return obj?.isDeleted;
  if (obj?.status === "Doado" || obj?.status === "Vendido") return true;
  return false;
}

function convertDateOfData(obj) {
  if (!obj?.purchase_date) return obj;
  const dateConvert = convertDate(obj?.purchase_date);
  const data: IImmobilizedInventory = {
    ...obj,
    purchase_date: dateConvert,
  };
  return data;
}
